export default {
  next_products_url: "products?page=1",
  next_products_url_search: "",
  products: [],
  new_products: [],
  success: "",
  errors: [],
  error_msg: "",
};
